export default __webpack_public_path__ + "static/media/loading.1ac3987e.gif";